var map = {
	"./about.json": 846,
	"./company.json": 847,
	"./contact.json": 848,
	"./directors.json": 849,
	"./grid.json": 850,
	"./history.json": 851,
	"./home.json": 852,
	"./iframe.json": 853,
	"./interactive.json": 854,
	"./keyfacts.json": 855,
	"./our-group.json": 856,
	"./private-label-supply-chain-country.json": 857,
	"./private-label-supply-chain.json": 858,
	"./shareprice.json": 859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 845;